import React from 'react';
import '../assets/styles/Contact.scss';

function Contact() {
  return (
    <div id="contact">
      <div className="contact_wrapper">
        <h1>Contact Me</h1>
        <p>Got a project waiting to be realized? Let's collaborate and make it happen!</p>

        <p className="email-link">
          <a href="mailto:martinytso99@gmail.com">
            martinytso99@gmail.com
          </a>
        </p>
      </div>
    </div>
  );
}

export default Contact;
